module.exports = __webpack_public_path__ + "images/avatars/male/13.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/13.png
// module id = WHLm
// module chunks = 118